import React, { useState } from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Checkbox from '@mui/material/Checkbox';
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { useDispatch, useSelector } from "react-redux";
import { setState } from "../scenarioSetupNewSlice";
import {Box}
 from "@mui/material";
import { useEffect } from "react";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

 
const AutoCompleteMS = () => {
    const {
      productGroupsForMS,selectedReferenceSKU
 
  } = useSelector((store) => store.scenarioSetupNew);
  const dispatch = useDispatch();
 
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedName, setselectedName] = useState('');
  const [isAllSelected, setIsAllSelected] = useState(false);
  const [selectedCount, setselectedCount] = useState(0);
  const [firstIndex, setfirstIndex] = useState(0);
  const [selectedOptions, setSelectedOptions] = useState(selectedReferenceSKU);
  const [firstTime, setFirstTime] = useState(true);
  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };
  useEffect(() => {
    if(selectedOptions !== undefined && selectedOptions.length !== 0 && firstTime === true){
      let ids = selectedOptions.map(x => (x.id));
      let filter = productGroupsForMS?.filter(item => ids.includes(item.id))
      setSelectedOptions(filter);
      setFirstTime(false);
      if(selectedOptions.length > 1){
        setfirstIndex(1);
      }else{
        setfirstIndex(0);
      }
      setselectedCount(selectedOptions?.filter(item => item.id !== 0).length);

    }
  }, [selectedOptions]);
  const handleOptionSelect = (event, newValue) => {
    dispatch(setState("marketShareComparisonList", []));
		dispatch(setState("marketShareGraphData", []));
    let isSelectedAll = false;
    let isselected = false;
    let isUnselectAll = false;
    let isLastSelected = false;
    const options = JSON.parse(JSON.stringify(productGroupsForMS));
    isSelectedAll = isAllSelected;
    if(newValue.length > 0){
      if(newValue[newValue.length-1].id === 0){
          isLastSelected = true;
          isSelectedAll = true;
          setIsAllSelected(true);
      }
    }
    if(isSelectedAll){
      let idx = newValue.findIndex(item => item.id === 0);
      if(idx === -1){
        isSelectedAll = false;
        setIsAllSelected(false);
        isUnselectAll = true;
      }
    }
    if(!isLastSelected && !isUnselectAll){
      let idx = newValue.findIndex(item => item.id === 0);
      if(idx !== -1){
        isselected = true;
      }
      if(newValue.length === productGroupsForMS.length-1 && isselected === true){
        isSelectedAll = false;
        setIsAllSelected(false);
      }
      if(newValue.length === productGroupsForMS.length-1 && isselected === false){
        isSelectedAll = true;
        setIsAllSelected(true);
      }
    }
    if(isSelectedAll){
        setSelectedOptions(productGroupsForMS);
        dispatch(setState("selectedReferenceSKU",productGroupsForMS));
        if(productGroupsForMS.length > 1){
          setfirstIndex(1);
        }else{
          setfirstIndex(0);
        }
        setselectedCount(productGroupsForMS.length-1);
    }
    else if(isUnselectAll){
        setSelectedOptions([]);
        dispatch(setState("selectedReferenceSKU",[]));
        setselectedName('');
        setselectedCount(0);
    }
    else if(newValue.length === productGroupsForMS.length-1 && isselected === true){
      let list = newValue?.filter(item => item.id !== 0);
      setSelectedOptions([]);
      setSelectedOptions(list);
      dispatch(setState("selectedReferenceSKU",newValue?.filter(item => item.id !== 0)));
      setselectedName(newValue[1].name);
      setselectedCount(newValue.length-1);
      setfirstIndex(1);
    }
    else {
        setSelectedOptions(newValue);
        dispatch(setState("selectedReferenceSKU",newValue));
        setselectedCount(newValue.length);
        if(newValue.length > 0){
          setselectedName(newValue[0].name);
        }
        else{
          setselectedName('');
        }
        setfirstIndex(0);
        // if(newValue.length === productGroupsForMS.length-1){
        //   options[0].name = "Unselect All";
        //   options[0].id = -1;
        // }
        // else if(newValue.length === 0){
        //   options[0].name = "Select All";
        //   options[0].id = 0;
        // }
        // else if(newValue.length <productGroupsForMS.length-1){
        //   options[0].name = "Select All";
        //   options[0].id = 0;
        // }
        // dispatch(setState("productGroupsForMS", options));
      }
  };
  const handleOptionSelect1 = (event, newValue) => {
    dispatch(setState("marketShareComparisonList", []));
		dispatch(setState("marketShareGraphData", []));
    setSelectedOptions(newValue);
    dispatch(setState("selectedReferenceSKU",newValue));
    setselectedCount(newValue.length);
    if(newValue.length > 0){
      setselectedName(newValue[0].name);
    }
    else{
      setselectedName('');
    }
    setfirstIndex(0);

  };
 
  const handleSelectAllSearched = () => {
    const searchedOptions = productGroupsForMS?.filter(option =>
      option.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setSelectedOptions(searchedOptions);
  };
 
  const handleInputChange = (event, newInputValue) => {
    // if(newInputValue !== ''){
    //     let index = productGroupsForMS.findIndex(option => (option.name === 'Select All' || option.name === 'Unselect All'));
    //     if(index !== -1){
    //         productGroupsForMS.splice(index, 1);
    //     }
    // }
    // else{
    //     if(selectedOptions.length === productGroupsForMS.length){
    //         productGroupsForMS.unshift({ name: "Unselect All", value: false });
    //     }
    //     else{
    //         productGroupsForMS.unshift({ name: "Select All", value: true });
    //     }
    // }
 
    // const filteredOptions = productGroupsForMS.filter((option) =>
    //  (option.name.toLowerCase().includes(newInputValue.toLowerCase() || option.name === 'Select All' || option.name === 'Unselect All'))
    // );
  };
  const renderOption = (props, option, { selected }) => {
 
    const backgroundColor = option.name === 'Select All' ? '#f0f0f0' : 'transparent';
    const fontSize = option.name === 'Select All' || option.name === 'Unselect All'? '20px' : '15px';
 
    return (
        <div>
     
      <li {...props} style={{ fontSize }}>
        <Checkbox
          icon={icon}
          checkedIcon={checkedIcon}
          style={{ marginRight: 8 }}
          checked={selected}
        />
        {option.name}
      </li>
      </div>
    );
  };
  const renderTags = (value, getTagProps) =>
  value.map((option, index) => (
    (index === firstIndex) && option.name !== "Select All"&&(
    <div key={index}{...getTagProps({ index })} style={{ fontSize: '12px'}}>
      {option.name.substring(0, 10)}  
          <b  style={{ fontSize: '15px'}}> ( {selectedCount} selected )</b>
    </div>
    )
  ));
 
  return (
    <div>
    <Autocomplete
    multiple
    id="checkboxes-tags-demo"
    options={productGroupsForMS}
    disableCloseOnSelect
    getOptionLabel={(option) => option.name}
    value={selectedOptions}
    onChange={handleOptionSelect}
    //onInputChange={handleInputChange}
    renderOption={renderOption}
    style={{ width: 300 }}
    size="small"
    renderInput={(params) => (
      <div>
      <TextField
          {...params}
          label="Reference SKUs"
          value={selectedOptions.length>0?selectedOptions[0].name:''}
        />
        </div>
    )}
    renderTags = {renderTags}
  />
  </div>
 
);
};
 
export default AutoCompleteMS;
 